import { useEffect, useState } from 'react';
import useDealRequest, {
  EDealRequestType,
  IDealRequestCommonSchema,
} from '../../../../../../api/hooks/use-deal-request';
import { toast } from 'react-toastify';

import BottomSheet from 'components/bottom-sheet';
import Header from 'components/header';
import FormRequest from 'screens/estimate/components/forms/formRequest/formRequest';
import { MarketTypes } from 'api/types';
import { IDataModal } from 'screens/estimate';
interface IModalSupportDealProps {
  isOpen: boolean;
  onDismiss: (value: boolean) => void;
  onAllReset?: () => void;
  marketType: MarketTypes;
  data: IDataModal;
  title?: string;
  type?: 'service' | 'support';
}
export interface IDataSupport {
  buildingId: number;
  facilityTypeId?: number;
  areaInSqM: string;
  address?: string;
  complexId?: number;
  streetId?: number;
}

const TEXT = `Отправьте заявку и мы отправим вам экспертный расчет рыночной стоимости в течении 2х рабочих дней.`;

const ModalSupportDeal = ({
  isOpen,
  data,
  onDismiss,
  onAllReset,
  marketType,
}: IModalSupportDealProps) => {
  const initDataSupport = {
    buildingId: data.buildingId,
    facilityTypeId: data.typeApartmentId,
    areaInSqM: data.areaInSqM,
    address: data.address,
    complexId: data.complexId,
    streetId: data.streetId,
  };

  const [dataSupport, setDataSupport] = useState<IDataSupport>(initDataSupport);

  const onChangeData = (value: string, key: string) => {
    setDataSupport((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    setDataSupport((prev) => ({
      ...prev,
      address: data.address,
      apartmentType: data.typeApartment,
      areaInSqM: data.areaInSqM,
      complexId: data.complexId,
      streetId: data.streetId,
    }));
  }, [data]);

  useEffect(() => {
    setDataSupport(initDataSupport);
  }, [isOpen]);

  const { error, isMutating, trigger } = useDealRequest();

  const handleSubmit = async () => {
    await trigger({
      marketType: marketType,
      type: EDealRequestType.Estimate,
      data: {
        buildingId: dataSupport.buildingId,
        areaInSqM: Number(dataSupport.areaInSqM),
        typeId: dataSupport.facilityTypeId,
        complexId: dataSupport.complexId,
        streetId: dataSupport.streetId,
      } as IDealRequestCommonSchema,
      mode: 'outOfSystem',
    });
    toast.success(
      'Ваша заявка принята, наш эксперт свяжется с вами в течении 2х часов в рабочее время.',
    );
    onAllReset && onAllReset();
    onDismiss(false);
  };

  return (
    <BottomSheet
      initialFocusRef={false}
      open={isOpen}
      header={<Header text={'Сервис оценки жилья'} />}
      onDismiss={() => onDismiss(false)}
      snapPoints={({ minHeight, maxHeight }) => [minHeight, maxHeight - 100]}
    >
      <FormRequest
        text={TEXT}
        buttonLabel='Обратиться в Reit'
        onClick={handleSubmit}
        data={dataSupport}
        onChange={onChangeData}
        isLoading={isMutating}
        type='default'
      />
    </BottomSheet>
  );
};

export default ModalSupportDeal;
